import { defineStore } from 'pinia'
import { UTM_KEYS } from '@/entities/utm/model/mapUtm'

const STORAGE_KEY = 'food_utm'
const MAX_LEN = 256

function normalizeUtmField(value) {
  if (value == null) {
    return null
  }
  const text = String(value).trim()
  if (!text) {
    return null
  }
  return text.slice(0, MAX_LEN)
}

export function parseUtmFromQuery(query = {}) {
  if (!query || typeof query !== 'object') {
    return null
  }

  const utm = {}
  let hasValue = false
  for (const key of UTM_KEYS) {
    const raw = query[key]
    if (raw == null) {
      continue
    }
    const normalized = normalizeUtmField(Array.isArray(raw) ? raw[0] : raw)
    if (normalized) {
      utm[key] = normalized
      hasValue = true
    }
  }
  return hasValue ? utm : null
}

function readUtmStorage() {
  if (typeof localStorage === 'undefined') {
    return null
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    return parseUtmFromQuery(JSON.parse(raw))
  } catch {
    return null
  }
}

function writeUtmStorage(utm) {
  if (typeof localStorage === 'undefined') {
    return
  }
  try {
    if (!utm) {
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(utm))
  } catch {
    void 0
  }
}

export const useUtmStore = defineStore('utm', {
  state: () => ({
    utm: null,
  }),
  actions: {
    restoreFromStorage() {
      this.utm = readUtmStorage()
    },

    setUtm(utm) {
      const normalized = parseUtmFromQuery(utm)
      if (!normalized) {
        return
      }
      this.utm = normalized
      writeUtmStorage(normalized)
    },

    captureFromQuery(query = {}) {
      if (this.utm) {
        return
      }
      this.setUtm(parseUtmFromQuery(query))
    },
  },
})
